export class UpLoadKPIShipmentDetailViewModel {
    code: string;
    name: string;
    wardId: number;
    districtId: number;
    vehicle: string;
    targetDeliveryTime: number;
    kPIShipmentId: number;
}